module.exports = __webpack_public_path__ + "static/img/cangzhouwei.54ae1e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cangzhouwei.png
// module id = 7S0k
// module chunks = 1